//栏目CID
export default {
  banner: 1590,
  //学院概况
  xyjj: 1545,
  mlxy: 1546,
  xyfg: 3991,
  sxsb: 3990,
  xysh: 3992,
  hdsg: 1593,
  // 专业设置
  zysz: 1536,
  // 招生专区
  zszq: 1537,
  ksgz: 4003,
  zsjz: 1565,
  hwlx: 1566,
  jnpx: 1567,
  // 就业保障
  jybz: 1538,
  yxsz: 1539,
  xggl: 1540,
  szjy: 1568,
  xssw: 1569,
  aqzx: 1570,
  xlzx: 1571,
  jxts: 1541,
  xxhjx: 1572,
  jxzg: 1573,
  ssfxjs: 1574,
  dsgzs: 1575,
  gjnjdjs: 1576,
  xwzx: 1542,
  xyyw: 1577,
  tzgg: 1578,
  mtgz: 1579,
  dtdt: 1543,
  djyl: 1580,
  dxzj: 1581,
  ggfw: 1544,
  dxzn: 1582,
  xxgk: 1583,
  bgyx: 1584,
  yycg: 1585,
  zxbm: 1586,
  syan: 1591,
  whhd: 5304,
}



// WEBPACK FOOTER //
// ./src/assets/js/api.js